(function(){
    'use strict';

    angular
    .module('appback')
    .controller('ReglasdescuentoController', ReglasdescuentoController)
 
    ReglasdescuentoController.$inject = ["ReglasdescuentoService","$http","$timeout","$uibModal", "$log", "$document","$sce"];
              
    function ReglasdescuentoController(ReglasdescuentoService,$http,$timeout,$uibModal, $log, $document,$sce)
    {                         
        var vm = this; 
        vm.loading = false;
        vm.checks = {};
        vm.centro_id = "";

        vm.cambiarValor = function(id){
        	var valor = ''; 
        	vm.loading = true;
        	//console.log(vm.checks);
        	ReglasdescuentoService.cambiarValor(id,vm.checks[id],vm.centro_id,function(data){
        		vm.loading = false;
				//$.pjax.reload('#pjax-grid-view', {timeout: 1000});
			});
        }

         vm.cambiarValorConfirm = function(id){
            var r = confirm("¿Seguro que quieres eliminar esta regla para este cliente?");
            if (r == true) {
              var valor = ''; 
                vm.loading = true;
                //console.log(vm.checks);
                ReglasdescuentoService.cambiarValor(id,0,vm.centro_id,function(data){
                    vm.loading = false;
                    location.reload();
                    //$.pjax.reload('#pjax-grid-view', {timeout: 1000});
                });
            } else {
              //txt = "You pressed Cancel!";
            }
            
        }

        //vm.init();
       
    }
  
})();